import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { provideNzIconsPatch } from "ng-zorro-antd/icon";
import { LanguageServices } from "src/app/services/LanguageServices";
import { CheckCircleTwoTone } from '@ant-design/icons-angular/icons';
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";

@Component({
    selector: 'webhook-form-keyvalue',
    templateUrl: './webhook-form-keyvalue.component.html',
    standalone: false,
    providers: [provideNzIconsPatch([CheckCircleTwoTone])]
})

export class WebhookFormKeyValueComponent implements OnInit {
     constructor(
            private fb:NonNullableFormBuilder, 
            private cd:ChangeDetectorRef
        
        ) {

    }

    
    pageIndex:number = 1;
    pageSize:number = 3;
    newRow = this.fb.group({
        key: ['', Validators.required],
        value: ['', Validators.required]
    });
    @Input() mainformGroup:FormGroup;
    @Input() field:any;
    @Input() fieldNew:string;
    @Input() n:number;
    @Input() variables:Variable[] = [];
    @Input() rootForm:FormGroup;
    @Input() configuration: any;
    
    filteredAutoCompleteKey:string[] = [];
    filteredAutoCompleteValue:string[] = [];
  
    ngOnInit(): void {
        if ( this.field.autocompleteKey != null ){
            this.newRow.get("key")?.valueChanges.subscribe(value => {
                this.filteredAutoCompleteKey = this.field.autocompleteKey.filter(opt =>{
                        if ( value == null){
                            return [];
                        }
                        return opt.toLowerCase().includes(value.toLowerCase())
                    }
                );
            });
        }

        if ( this.field.autocompleteValue != null ){
            this.newRow.get("value")?.valueChanges.subscribe(value => {
                this.filteredAutoCompleteValue = this.field.autocompleteValue.filter(opt =>{
                        if ( value == null){
                            return [];
                        }
                        return opt.toLowerCase().includes(value.toLowerCase())
                    }
                );
            });
        }
        
    }

    get rows(){
        const formArray = this.mainformGroup?.get(this.fieldNew) as FormArray;
        return formArray || this.fb.array([]);
    }

    get pagedRows() {
        const controls = this.rows?.controls || [];
        const start = (this.pageIndex - 1) * this.pageSize;
        return controls.slice(start, start + this.pageSize);
        
    }

    get rowsLength() {
        return this.rows?.length || 0;
    }


    
    addRow() {
        
        if (this.newRow.valid) {
           const currentRows = this.rows;
           if (currentRows) {
               const newFormGroup = this.fb.group({
                   key: [this.newRow.value.key || ''],
                   value: [this.newRow.value.value || '']
               });
               (currentRows as FormArray).push(newFormGroup as any);
               this.cd.detectChanges();

               const total = currentRows.length;
               const pages = Math.ceil(total / this.pageSize);
               this.pageIndex = pages;

               this.newRow.reset();
           }
        }
    }
    

    removeRow(index: number) {
        const currentRows = this.rows;
        if (currentRows) {
            currentRows.removeAt(index);
            this.cd.detectChanges();
        }
    }

  




}
